export { default as CompanyLogo } from "./company-logo";
